import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames'
//import ReactDOM from 'react-dom';

//import Aux from '../../hoc/beesaux/beesaux';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
//import withRoot from '../../withRoot';
//import * as actions from '../../store/actions/index';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
//import { Icon } from '@material-ui/core';
import { fade } from '@material-ui/core/styles/colorManipulator';
//import MenuIcon from '@material-ui/icons/Menu';
//import CssBaseline from '@material-ui/core/CssBaseline';
//import FormControl from '@material-ui/core/FormControl';
//import MenuItem from '@material-ui/core/MenuItem';
// import Select from '@material-ui/core/Select';
// import InputLabel from '@material-ui/core/InputLabel';
//import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import * as actions from '../../store/actions/index';
//import SearchBar from '@opuscapita/react-searchbar';
import SearchIcon from '@material-ui/icons/Search';
import Badge from '@material-ui/core/Badge';
//import InputBase from '@material-ui/core/InputBase';
import Input from '@material-ui/core/Input';
import PropTypes from 'prop-types';
import { memo } from 'react';
//import withWidth, { isWidthUp } from '@material-ui/core/withWidth'
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
import StarRoundedIcon from '@material-ui/icons/StarRounded';
import VpnLockIcon from '@material-ui/icons/VpnLock';
import PublicIcon from '@material-ui/icons/Public';
import HelpIcon from '@material-ui/icons/Help';
import LiveTvIcon from '@material-ui/icons/LiveTv';
//import { makeStyles, useTheme } from '@material-ui/styles';

//mobile use


const drawerWidth = 240;



const stylesNeuroactivity = theme => ({
  '@keyframes blink': {
    '0%': {
      opacity: 1,
    },
    '50%': {
      opacity: 0.2,
    },
    '100%': {
      opacity: 1,
    },
  },
})


const styles1 = theme => ({

  button: {
    margin: '5px',

    [theme.breakpoints.down('sm')]: {
       display: 'none',
       },
  },
   grow: {
      flexGrow: 1,

      [theme.breakpoints.down('sm')]: {
         display: 'none',
         },
    },
    marginForBadge: {
      margin: theme.spacing.unit * 1,

      [theme.breakpoints.down('sm')]: {
         display: 'none',
         },
    },
//     menuButton: {
//       marginLeft: -12,
//       [theme.breakpoints.up('md')]: {
//          display: 'none',
//          },
// },

    searchbardiv: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    searchbar: {
      display: 'flex',
      justifyContent: 'flex-end',

    },
    search: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: fade(theme.palette.common.white, 0.15),
      '&:hover': {
        backgroundColor: fade(theme.palette.common.white, 0.25),
      },
      marginLeft: 0,
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing.unit,
        width: 'auto',
      },
    },
    searchIcon: {
      width: theme.spacing.unit * 9,
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    inputRoot: {
      color: 'inherit',
      width: '100%',
    },
    inputInput: {
      paddingTop: theme.spacing.unit,
      paddingRight: theme.spacing.unit,
      paddingBottom: theme.spacing.unit,
      paddingLeft: theme.spacing.unit * 10,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        width: 120,
        '&:focus': {
          width: 200,
        },
      },
    },

  input: {
      color: '#adadad',
      backgroundColor: 'black',
      height: '4em', //think 14px for 1em
      textAlign: 'center',
      width: '100%',
      backgroundColor: ''
  },

// root: {
//   display: 'flex',
//   flexDirection: 'column',
//   flexWrap: 'wrap',
// },

root: {
   display: 'flex',
 },
 appBar: {

   transition: theme.transitions.create(['margin', 'width'], {
     easing: theme.transitions.easing.sharp,
     duration: theme.transitions.duration.leavingScreen,
   }),
 },
 appBarShift: {
   width: `calc(100% - ${drawerWidth}px)`,
   marginLeft: drawerWidth,
   transition: theme.transitions.create(['margin', 'width'], {
     easing: theme.transitions.easing.easeOut,
     duration: theme.transitions.duration.enteringScreen,
   }),
 },
 menuButton: {
   marginLeft: 12
 },
 hide: {
   display: 'none'
 },
 divider: {
   backgroundColor: '#676767'
 },
 drawer: {
   width: drawerWidth,
   flexShrink: 0,
 },
 drawerPaper: {
   width: drawerWidth,
   backgroundColor: '#512da8',
 },
 drawerHeader: {
   display: 'flex',
   alignItems: 'center',
   padding: '0 8px',
   ...theme.mixins.toolbar,
   justifyContent: 'flex-end',
 },
 favButton: {
   color: 'yellow'
 },
 neurchButton: {
   color: 'black'
 },
 neurchOKButton: {
   color: '#1bff00'
 },
 aboutOKButton: {
   color: 'white'
 },
 YTButton: {
   color: 'red'
 },
 labelDrawerItem: {
   color: 'white',
 },
 neuroactivityanimation: {
  animationName: 'blink',
  animationDuration: '2s',
  animationIterationCount: 'infinite',
  ...stylesNeuroactivity
 },
 content: {
   flexGrow: 1,
   padding: theme.spacing.unit * 3,
   transition: theme.transitions.create('margin', {
     easing: theme.transitions.easing.sharp,
     duration: theme.transitions.duration.leavingScreen,
   }),
   marginLeft: -drawerWidth,
 },
 contentShift: {
   transition: theme.transitions.create('margin', {
     easing: theme.transitions.easing.easeOut,
     duration: theme.transitions.duration.enteringScreen,
   }),
   marginLeft: 0,
 },
});

const MyAppBarMemoChild = memo(({ signout,mode,someoneelsesbrain, articleMode, editMode,appbarFuncClickedOnBack,
  appbarFuncClickedOnProfile, anomalyCount,appbarFuncClickedOnAnomalies,setLoadingOverlayControllerToTrueRef,fetchlatestentriesRef, fetchlatestentriesmode2Ref, appbarFuncClickedOnLatestEntries,newEntryClicked,setLocalStatesToEntryMode, fetchentriesRef,
  fetchentriesbycontentRef, nodes, dataentriessymboltable,dataentries, nodes_st,filterednodes, appbarFuncSearchedEntry,classes, width, handleDrawerClose,handleDrawerOpen,displaySearchNodes, displaySearchEntries, handleDisplaySearchNodes, handleDisplaySearchEntries, appbarFuncClickedOnFavorites, custom_data,custom_data_anotheruser,changeModeFrom1to3AndBackRef,changeToSpecificMode,fetchYTStreamInfo, open, infoPressed, showTV,getDataEntriesPinpointMode3,fetchLatestEntriesMode3Ref,appbarFuncClickedOnSomethingNewStyle,getDataEntriesForMeModeMode3, theme }) => {

    if(width) //mobile mode
    {
      return (
        <div>
        <AppBar position="static" visable={true} className={classNames(classes.appBar, {
              [classes.appBarShift]: open,
            })} >
           <Toolbar disableGutters={!open}>
             <Typography variant="h6" color="inherit" className={classes.grow}>
               NEARCHER
             </Typography>
             <IconButton
             className={classes.menuButton}
             color="inherit"
             aria-label="Open drawer"
             className={classNames(classes.menuButton, open && classes.hide)}
             onClick={handleDrawerOpen}

             ><MenuIcon /> </IconButton>
             {mode === 1 ? <IconButton className={classes.neurchButton} onClick={() => {changeModeFrom1to3AndBackRef();fetchLatestEntriesMode3Ref(1);  handleDisplaySearchEntries(); appbarFuncSearchedEntry()}} fontSize="large" size="large" >
      <VpnLockIcon />
  </IconButton> : <IconButton className={classes.neurchOKButton} onClick={() => {changeModeFrom1to3AndBackRef(); appbarFuncSearchedEntry()}} fontSize="large" size="large" >
<PublicIcon />
</IconButton>}
             {mode === 1 ? <IconButton className={classes.favButton} onClick={() => {appbarFuncClickedOnFavorites()}} aria-label="Open drawer" fontSize="large" size="large" >
      <StarRoundedIcon />
  </IconButton> : false}
             <Button color="inherit" className={classes.button} onClick={() => {signout();}}>Sign Out</Button>
             <Button color="inherit" className={classes.button} onClick={(event) => {appbarFuncClickedOnProfile();}}>Profile</Button>
             {(mode === 1) ? <Badge badgeContent={anomalyCount} color="error" className={classes.marginForBadge}><Button color="inherit" className={classes.button} onClick={(event) => {appbarFuncClickedOnAnomalies()}}>Control</Button></Badge> : false}
             <Button color="inherit" className={classes.button} onClick={() => {setLoadingOverlayControllerToTrueRef(); if(mode === 1){fetchlatestentriesRef();} if(mode === 2){fetchlatestentriesmode2Ref(0, custom_data_anotheruser.owner_id);} appbarFuncClickedOnLatestEntries()}}>Latest Entries</Button>
             <Button color="inherit" className={classes.button} onClick={(event) => {newEntryClicked(event, setLocalStatesToEntryMode)}}>New Entry</Button>

    {(mode === 1 || mode === 3) ? displaySearchNodes ?

    <div className={classes.search}>
    <div className={classes.searchIcon}>
      <SearchIcon />
    </div>
    <Input
      placeholder="Search Nodes..."

      classes={{
        root: classes.inputRoot,
        input: classes.inputInput,
      }}

      //{{className: classes.textField}}
      onChange={(event) => {

        if(mode === 1)
        {
          fetchentriesRef(nodes, event.target.value, dataentriessymboltable, dataentries, nodes_st, filterednodes);
          appbarFuncSearchedEntry()
        }
        if(mode === 3)
        {
          getDataEntriesPinpointMode3(event.target.value.toUpperCase())
          appbarFuncSearchedEntry()
        }

    } } //careful filterNodesRef is an async op so might be too slow to go fetch the hooks,
    />
           </div> : false
           : false}

    { (displaySearchEntries) ? <div className={classes.search}>
    <div className={classes.searchIcon} >
      <SearchIcon />
    </div>
    <Input
      placeholder="Search Entries..."
      classes={{
        root: classes.inputRoot,
        input: classes.inputInput,
      }}

    onClick={(event)=> {if(event.target.value.length > 0){fetchentriesbycontentRef(event.target.value, "2", mode, custom_data_anotheruser.owner_id); appbarFuncSearchedEntry(); if(mode === 2){changeToSpecificMode(3)}}}}
    onKeyDown={(e)=> {if(e.keyCode == 13){
       if(e.target.value.length > 0){fetchentriesbycontentRef(e.target.value, "2", mode, custom_data_anotheruser.owner_id); appbarFuncSearchedEntry(); if(mode === 2){changeToSpecificMode(3)}}
       // put the login here
    }}}
    />
    </div> : false}


           </Toolbar>
         </AppBar>
         <Drawer
            className={classes.drawer}
            variant="persistent"
            anchor="left"
            open={open}
            classes={{
              paper: classes.drawerPaper,
            }}
          >
            <div className={classes.drawerHeader}>
              <IconButton onClick={handleDrawerClose}>
                <ChevronLeftIcon />
              </IconButton>
            </div>
            <Divider classes={{root: classes.divider}} />
            <List>



                { (mode === 1) ? <ListItem button key={'New Entry'} onClick={(event)=>{newEntryClicked(event, setLocalStatesToEntryMode); handleDrawerClose();}}><ListItemText classes={{primary: classes.labelDrawerItem}} primary={'New Entry'}/></ListItem> : false}
                <ListItem button key={'Search Nodes'} onClick={()=>{handleDisplaySearchNodes();handleDrawerClose();}}> <ListItemText classes={{primary: classes.labelDrawerItem}} primary={'Search Nodes'}/> </ListItem>
                <ListItem button key={'Search Entries'} onClick={()=>{ handleDisplaySearchEntries(); handleDrawerClose();}}>
                  <ListItemText classes={{primary: classes.labelDrawerItem}} primary={'Search Entries'}/>
                </ListItem>

                {mode != 3 ?
                  <ListItem button key={'Latest Entries'} onClick={()=>{setLoadingOverlayControllerToTrueRef(); if(mode === 1){fetchlatestentriesRef();} if(mode === 2){fetchlatestentriesmode2Ref(0, custom_data_anotheruser.owner_id);} appbarFuncClickedOnLatestEntries(); handleDrawerClose();}}>
                    <ListItemText classes={{primary: classes.labelDrawerItem}} primary={'Latest Entries'}/>
                  </ListItem>
                  : false}

                  {mode === 3 ?
                    <ListItem button key={'4me'} onClick={()=>{getDataEntriesForMeModeMode3(); appbarFuncClickedOnSomethingNewStyle("ForMeMode"); handleDrawerClose(); }}>
                      <ListItemText classes={{primary: classes.labelDrawerItem}} primary={'For Me'}/>
                    </ListItem>
                     : false}


                  {mode === 3 ?
                    <ListItem button key={'Brain Bridge'} onClick={()=>{fetchLatestEntriesMode3Ref(2); handleDrawerClose(); appbarFuncClickedOnSomethingNewStyle("BBMode"); }}>
                      <ListItemText classes={{primary: classes.labelDrawerItem}} primary={'Brain Bridge'}/>
                    </ListItem>
                     : false}
               {mode === 3 ?
                 <ListItem button key={'na'} onClick={()=>{fetchLatestEntriesMode3Ref(1); handleDrawerClose(); appbarFuncClickedOnSomethingNewStyle("latestEntriesMode")}}>
                   <ListItemText primary={'Neuroactivity'}/>
                 </ListItem>
                  : false} 
                  {mode === 3 ?
                    <ListItem button key={'no'} onClick={()=>{appbarFuncClickedOnSomethingNewStyle("NEMode"); handleDrawerClose(); }}>
                      <ListItemText classes={{primary: classes.labelDrawerItem}} primary={'Neuroevents'}/>
                    </ListItem>
                     : false}

                  {mode != 3 ?
                    <ListItem button key={'Brofile'} onClick={()=>{appbarFuncClickedOnProfile(); handleDrawerClose();}}>
                      <ListItemText classes={{primary: classes.labelDrawerItem}} primary={'Brofile'}/>
                    </ListItem>
                     : false}






                {mode === 1 ? <ListItem button key={'Controls'} onClick={()=>{appbarFuncClickedOnAnomalies(); handleDrawerClose();}}><ListItemText classes={{primary: classes.labelDrawerItem}} primary={'Controls'}/></ListItem> : false}
                <ListItem button key={'Help'} onClick={()=>{infoPressed(); handleDrawerClose();}}>
                  <ListItemText classes={{primary: classes.labelDrawerItem}} primary={'Help'}/>
                </ListItem>
                <ListItem button key={'Sign Out'} onClick={()=>{signout(); handleDrawerClose();}}>
                  <ListItemText classes={{primary: classes.labelDrawerItem}} primary={'Sign Out'}/>
                </ListItem>
            </List>
            <Divider classes={{root: classes.divider}}/>
          </Drawer>
          </div>


      )
    }
    else { //non-mobile mode.
      return (
          <AppBar position="static" visable={true}>
             <Toolbar>
               <Typography variant="h6" color="inherit" className={classes.grow}>
                 Nearcher
               </Typography>



               {showTV ? <IconButton className={classes.YTButton} onClick={(event) => {fetchYTStreamInfo();}} fontSize="large" size="large" >
               <LiveTvIcon />
               </IconButton> : false}



               {mode === 1 ? <IconButton className={classes.neurchButton} onClick={() => {changeModeFrom1to3AndBackRef(); fetchLatestEntriesMode3Ref(1); appbarFuncSearchedEntry()}} fontSize="large" size="large" >
        <VpnLockIcon />
    </IconButton> : <IconButton className={classes.neurchOKButton} onClick={() => {changeModeFrom1to3AndBackRef(); appbarFuncSearchedEntry()}} fontSize="large" size="large" >
<PublicIcon />
</IconButton>}
                {mode === 3 ? <Button color="inherit" className={classes.button} onClick={() => { getDataEntriesForMeModeMode3();  appbarFuncClickedOnSomethingNewStyle("ForMeMode");}}>For Me</Button> : false}
                {mode === 3 ? <Button color="inherit" className={classes.button} onClick={() => {appbarFuncClickedOnSomethingNewStyle("NEMode")}}>Neuroevents</Button> : false}
                {mode === 3 ? <Button color="inherit" classes={{root: classes.neuroactivityanimation, label: classes.neuroactivityanimation, text: classes.neuroactivityanimation}}  onClick={() => {fetchLatestEntriesMode3Ref(1); appbarFuncClickedOnSomethingNewStyle("latestEntriesMode")}}>Neuroactivity</Button> : false}
                {mode === 3 ? <Button color="inherit" className={classes.button} onClick={() => {fetchLatestEntriesMode3Ref(2); appbarFuncClickedOnSomethingNewStyle("BBMode")}}>Brain Bridge</Button> : false}


               <Button color="inherit"  onClick={() => {signout();}}>Sign Out</Button>
               {(mode != 3) ? <Button color="inherit"  onClick={(event) => {appbarFuncClickedOnProfile();}}>Brofile</Button> : false}
               {(mode === 1) ? <Badge badgeContent={anomalyCount} color="error" className={classes.marginForBadge}><Button color="inherit"  onClick={(event) => {appbarFuncClickedOnAnomalies()}}>Control</Button></Badge> : false}
               {(mode != 3) ? <Button color="inherit"  onClick={() => {setLoadingOverlayControllerToTrueRef(); if(mode === 1){fetchlatestentriesRef();} if(mode === 2){fetchlatestentriesmode2Ref(0, custom_data_anotheruser.owner_id);} appbarFuncClickedOnLatestEntries()}}>Latest Entries</Button> : false}
               {(mode === 1) ? <Button color="inherit" className={classes.button} onClick={() => {appbarFuncClickedOnFavorites()}}>Favorites</Button> : false}
               { (mode === 1) ? <Button color="inherit"  onClick={(event) => {newEntryClicked(event, setLocalStatesToEntryMode)}}>New Entry</Button> : false}

      {mode === 1 || mode === 3  ?

      <div className={classes.search}>
      <div className={classes.searchIcon}>
        <SearchIcon />
      </div>
      <Input
      autoFocus={true}
        placeholder="Search Nodes..."
        classes={{
          root: classes.inputRoot,
          input: classes.inputInput,
        }}

        //{{className: classes.textField}}
        onChange={(event) => {

          if(event.target.value.length > 0){

            if(mode === 1)
            {
              fetchentriesRef(nodes, event.target.value, dataentriessymboltable, dataentries, nodes_st, filterednodes);
              appbarFuncSearchedEntry()
            }
            if(mode === 3)
            {
              getDataEntriesPinpointMode3(event.target.value.toUpperCase())
              appbarFuncSearchedEntry()
            }


          }

      } } //careful filterNodesRef is an async op so might be too slow to go fetch the hooks,
      />
             </div>
             : false}

      <div className={classes.search}>
      <div className={classes.searchIcon}>
        <SearchIcon />
      </div>
      <Input
        placeholder="Search Entries..."
        classes={{
          root: classes.inputRoot,
          input: classes.inputInput,
        }}



        //{{className: classes.textField}}
        //console.log("PWM", event.target.value.substr(event.target.value.length-1, event.target.value.length) == "@");

      onClick={(event)=> {if(event.target.value.length > 0){fetchentriesbycontentRef(event.target.value, "2", mode, custom_data_anotheruser.owner_id); appbarFuncSearchedEntry(); if(mode === 2){changeToSpecificMode(3)}}}}
      onKeyDown={(e)=> {if(e.keyCode == 13){
         if(e.target.value.length > 0){fetchentriesbycontentRef(e.target.value, "2", mode, custom_data_anotheruser.owner_id); appbarFuncSearchedEntry(); if(mode === 2){changeToSpecificMode(3)}}
         // put the login here
      }}}


      />
      </div>
      <IconButton className={classes.aboutOKButton} onClick={(event) => {infoPressed()}} fontSize="large" size="large" >
      <HelpIcon />
      </IconButton>

             </Toolbar>
           </AppBar>


        )

    } //not mobile mode

});


const MyAppBar = React.memo(function MyAppBarWrapper(props) {

  const { classes } = props;

    //const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const [displaySearchNodes, setDisplaySearchNodes] = React.useState(true);
    const [displaySearchEntries, setDisplaySearchEntries] = React.useState(false);


    function handleDisplaySearchEntries() {
    setDisplaySearchNodes(false);
    setDisplaySearchEntries(true);
  }

  function handleDisplaySearchNodes() {
  setDisplaySearchNodes(true);
  setDisplaySearchEntries(false);
}

  function handleDrawerClose() {
  setOpen(false);
}
function handleDrawerOpen() {
   setOpen(true);
 }


  //console.log(classes.grow, "hello");
    return (

  <MyAppBarMemoChild getDataEntriesForMeModeMode3={props.getDataEntriesForMeModeMode3} displaySearchNodes={displaySearchNodes} displaySearchEntries={displaySearchEntries} handleDisplaySearchNodes={handleDisplaySearchNodes} handleDisplaySearchEntries={handleDisplaySearchEntries} handleDrawerClose={handleDrawerClose} handleDrawerOpen={handleDrawerOpen} mode={props.mode} someoneelsesbrain={props.someoneelsesbrain} signout={props.signout} appbarFuncSearchedEntry={props.appbarFuncSearchedEntry} appbarFuncClickedOnProfile={props.appbarFuncClickedOnProfile} dataentries={props.dataentries} dataentriessymboltable={props.dataentriessymboltable} nodes_st={props.nodes_st} nodes={props.nodes} filterednodes={props.filterednodes} fetchentriesRef={props.fetchentriesRef} fetchentriesbycontentRef={props.fetchentriesbycontentRef} setLocalStatesToEntryMode={props.setLocalStatesToEntryMode} newEntryClicked={props.newEntryClicked} appbarFuncClickedOnLatestEntries={props.appbarFuncClickedOnLatestEntries}  fetchlatestentriesRef={props.fetchlatestentriesRef} fetchlatestentriesmode2Ref={props.fetchlatestentriesmode2Ref} setLoadingOverlayControllerToTrueRef={props.setLoadingOverlayControllerToTrueRef} appbarFuncClickedOnAnomalies={props.appbarFuncClickedOnAnomalies} articleMode={props.articleMode} editMode={props.editMode} appbarFuncClickedOnBack={props.appbarFuncClickedOnBack} anomalyCount={props.anomalyCount} classes={classes} width={props.width} open={open} appbarFuncClickedOnFavorites={props.appbarFuncClickedOnFavorites} custom_data={props.custom_data} custom_data_anotheruser={props.custom_data_anotheruser} changeModeFrom1to3AndBackRef={props.changeModeFrom1to3AndBackRef} changeToSpecificMode={props.changeToSpecificModeRef} infoPressed={props.infoPressed} fetchYTStreamInfo={props.fetchYTStreamInfo} showTV={props.showTV} getDataEntriesPinpointMode3={props.getDataEntriesPinpointMode3} fetchLatestEntriesMode3Ref={props.fetchLatestEntriesMode3Ref} appbarFuncClickedOnSomethingNewStyle={props.appbarFuncClickedOnSomethingNewStyle}/>


  )

});


MyAppBar.propTypes = {
  articleMode: PropTypes.bool,
  editMode: PropTypes.bool,
  isInDataEntryMode: PropTypes.bool,
  appbarFuncClickedOnBack: PropTypes.func,
  anomalyCount: PropTypes.number,
  appbarFuncSearchedEntry: PropTypes.func,
};

const mapStateToProps = state => {
    return {
      nodes: state.signIn.nodes,
      dataentriessymboltable: state.signIn.dataentries_symboltable,
      dataentries: state.signIn.dataentries,
      nodes_st: state.signIn.nodes_symboltable,
      filterednodes: state.signIn.filtered_nodes,
      mode: state.signIn.mode,
      custom_data: state.signIn.custom_data,
      custom_data_anotheruser: state.signIn.custom_data_anotheruser,
    }
  }
const mapDispatchToProps = dispatch => {
    return {
      setLoadingOverlayControllerToTrueRef: () => dispatch(actions.setLoadingOverlayControllerToTrue()),
      fetchlatestentriesRef: () => dispatch(actions.fetchLatestEntries()),
      fetchlatestentriesmode2Ref: (whichtoget,ownerid) => dispatch(actions.fetchLatestEntriesMode2(whichtoget,ownerid)),
      fetchentriesRef: (nodedataentriestofetch, filter, dataentriessymboltable, dataentries, nodes_st, filterednodes) => dispatch(actions.fetchEntries(nodedataentriestofetch, filter, dataentriessymboltable, dataentries, nodes_st, filterednodes)),
      fetchentriesbycontentRef: (texttosearch, filter, mode, someoneelsesbrain) => dispatch(actions.fetchEntriesByContent(texttosearch, filter, mode, someoneelsesbrain)),
      changeModeFrom1to3AndBackRef: () => dispatch(actions.changeModeFrom1to3AndBack()),
      changeToSpecificModeRef: (mo) => dispatch(actions.changeToSpecificMode(mo)),
      fetchLatestEntriesMode3Ref: (mo) => dispatch(actions.fetchLatestEntriesMode3(mo)),
      //: (pinpointednodes) => dispatch(actions.setPinpointedNodes(pinpointednodes)),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler( withStyles(styles1)(MyAppBar) ));
